import {ULIDtoUUID, UUIDtoULID} from "ulid-uuid-converter"
import {useShortItemId} from "~/composables/useShortItemId"

export const useApiIdConverter = () => {
  const logger = useFrontendLogger()

  const apiIdToUuid = (id?: string) => {
    if (!id) {
      return undefined
    }
    try {
      const uuid = useShortItemId(id)
      if (!uuid) {
        return undefined
      }
      return ULIDtoUUID(uuid)
    } catch (e) {
      logger.error('Error useApiIdConverter.apiIdToUuid', {
        id,
        e
      })
      return undefined
    }
  }

  const uuidToUlid = (id: string, prefix: string = ''): string => {
    return `${prefix}${UUIDtoULID(id)}`
  }

  return {
    apiIdToUuid,
    uuidToUlid
  }
}